import React, { useMemo } from 'react';

import { Box, Typography } from '@mui/material';
import moment from 'moment';

import {
  adminCalendar,
  adminInfo,
  AdminLegendVariant,
  convertToDecimals,
  userIdSelector,
} from '@pharmaplan/common';

import { useAppSelector } from '../../../../hooks/useAppSelector';
import strings from '../../../../localization';

import styles from './styles';

/**
 * Month-wise ownership snapshot for the signed-in admin. The calendar is
 * already fetched for the visible month, so summing its bookings keeps the
 * hours in step with whatever the admin is looking at.
 */
const OwnershipSummary = () => {
  const calendar = useAppSelector(adminCalendar);
  const info = useAppSelector(adminInfo);
  const currentUserId = useAppSelector(userIdSelector);

  const { numberOfAccounts = 0 } = info ?? {};

  const bookedHours = useMemo(
    () =>
      calendar
        .filter(
          (item) =>
            item.type === AdminLegendVariant.booked
            && item.ownerId === currentUserId,
        )
        .reduce(
          (total, { startDate, endDate }) =>
            total + moment(endDate).diff(moment(startDate), 'hours', true),
          0,
        ),
    [calendar, currentUserId],
  );

  const stats = [
    { key: 'accounts', label: strings.assignedAccounts, value: numberOfAccounts },
    {
      key: 'hours',
      label: strings.totalBookedHours,
      value: convertToDecimals(bookedHours),
    },
  ];

  return (
    <Box sx={styles.container}>
      {stats.map(({ key, label, value }) =>
        (
          <Box key={key} sx={styles.stat}>
            <Typography sx={styles.label}>
              {label}
              :
            </Typography>
            <Typography sx={styles.value}>{value}</Typography>
          </Box>
        ))}
    </Box>
  );
};

export default OwnershipSummary;
